import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { BASE_URL } from "../BaseURL";

const ProjectsPreview = ({ projects, categoryMap }) => {
  const navigate = useNavigate();

  return (
    <div className="projects-grid">
      {projects.map((project) => (
        <div
          key={project._id}
          className="project-card"
          onClick={() => navigate(`/projects/${project._id}`)}
        >
          <div className="project-card-inner">
            <div className="project-image-wrapper">
              <img
                src={
                  project.images?.length
                    ? `${BASE_URL}${project.images[0]}`
                    : "https://via.placeholder.com/400x220"
                }
                alt={project.title}
              />
              <span className="project-category-badge">
                {categoryMap[project.category]}
              </span>
            </div>

            <div className="project-info">
              <h3>{project.title}</h3>
              <p className="project-description">
                {project.description
                  ?.replace(/<[^>]+>/g, "")
                  .slice(0, 90)}
                ...
              </p>

              <button className="view-more-btn">
                View Details <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectsPreview;
